import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-searching',
  templateUrl: './dialog-searching.component.html',
  styleUrl: './dialog-searching.component.scss'
})
export class DialogSearchingComponent {


  public _dialogRef = inject(MatDialogRef<DialogSearchingComponent>);
 
  

}
